import { render, staticRenderFns } from "./NewMembershipModal.vue?vue&type=template&id=000b58e2&"
import script from "./NewMembershipModal.vue?vue&type=script&lang=js&"
export * from "./NewMembershipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports